import { usePersonalAccounts } from '@/api/models/finance/hooks/usePersonalAccounts'
import { SwiperOption } from '@/components/shared/types-selector/TypesSelector.types'

import { ALL_FILTER } from '../Bills.constants'

export const usePremises = () => {
  const {
    data: personalAccounts,
    isLoading,
    isError,
    error
  } = usePersonalAccounts()

  const premiseOptions =
    personalAccounts?.map(personalAccount => ({
      key: personalAccount.personalAccountId,
      title: personalAccount.premiseName,
      marked: personalAccount.hasDebt
    })) || []

  const getSelectedPremise = (selectedTab: SwiperOption) => {
    if (premiseOptions.length === 1) {
      return premiseOptions[0]
    } else {
      return selectedTab.key === ALL_FILTER.key ? undefined : selectedTab
    }
  }

  const getPremiseNameById = (premiseId: string) => {
    return premiseOptions.find(premise => premiseId === premise.key)?.title
  }

  return {
    isLoading,
    isError,
    error,
    premiseOptions,
    getSelectedPremise,
    getPremiseNameById
  }
}
